// extracted by mini-css-extract-plugin
export var dropdown = "SingleSelect-module--dropdown--83fc0";
export var menuItem = "SingleSelect-module--menuItem--a01d1";
export var selectButton = "SingleSelect-module--selectButton--4a424";